<template>
  <div v-rect-loading="loading" class="email-template-list">
    <TableList
      :listData="listData"
      :tableColumns="tableColumns"
      :actionBtn="actionBtn"
      @create="handleCreate"
    >
    </TableList>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import TableList from '@/components/tableList/allowDragSortTable.vue'

export default {
  components: {
    TableList
  },
  data () {
    return {
      loading: false,
      i18nPrefix: 'admin.company.jobApplication',
      listData: []
    }
  },
  computed: {
    previewLocale () {
      return this.$parent.activePreviewLocale
    },
    tableColumns () {
      const columns = [
        {
          label: this.$t(`${this.i18nPrefix}.label.emailSubject`),
          dataKey: 'subject',
          width: '300px'
        },
        {
          label: this.$t(`${this.i18nPrefix}.label.emailType`),
          dataKey: 'type',
          width: '100px',
          formatter: (data) => {
            switch (data) {
              case 1:
              case '1':
                return 'invitation'
              case 2:
              case '2':
                return 'reminder'
              default:
                return '-'
            }
          }
        }
      ]
      return columns
    },
    actionBtn () {
      return {
        edit: {
          isShow: true,
          onclick: this.handleEdit
        }
      }
    }
  },
  created () {
    this.fetchListData()
  },
  methods: {
    ...mapActions('jobApplicationManagement', [
      'searchEmailTemplate'
    ]),
    async fetchListData () {
      this.loading = true
      try {
        const resp = await this.searchEmailTemplate()
        if (resp && resp.email_template) {
          this.listData = resp.email_template
        }
      } finally {
        this.loading = false
      }
    },
    handleEdit (rowData) {
      this.$router.push(`/v-admin/job-application-management/email-template/edit/${rowData.id}`)
    },
    handleCreate () {
      this.$router.push('/v-admin/job-application-management/email-template/add')
    }
  }
}
</script>

<style lang='sass' scoped>

</style>
